import React from 'react'
import { useNavigate } from 'react-router-dom';

const CenterLoginNavigateModal = ({ showModal, pathname, onclose }) => {
    const navigate = useNavigate();

    if (!showModal) return null;

    return (
        <>

            <div className="modal-backdrop fade show" onClick={onclose}></div>

            <div className="modal show d-flex justify-content-center" tabIndex="-1" style={{ display: "block" }}>
                <div className="modal-dialog-centered loginWarningDialog" style={{ maxWidth: "360px" }}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="ff-poppins-semiBold fs-16 primary-text text-center">
                                Attention!
                            </div>
                            <div className="ff-poppins-medium fs-13 text-center mt-2">
                                To proceed further please login and get the pingle experience.
                            </div>
                            <div className="d-flex justify-content-evenly mt-3" role="button" >
                                <div className="loginBtn text-light  primary-bg "
                                    onClick={() => { localStorage.setItem('vendorUrl', pathname); navigate("/login", { state: { fromGuest: true } }) }}>
                                    Login
                                </div>
                                <div className="loginBtn  primary-text primary-bg-light" onClick={onclose}>
                                    Close
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CenterLoginNavigateModal;
